export default {
  treatmentReport: 'รายงานการรักษา',
  treatmentReports: {
    search: 'ค้นหาชื่อแพทย์, คนไข้',
    selectDay: 'เลือกระยะเวลา',
    selectTreatment: 'เลือกการรักษา',
    day: 'วันที่รักษา',
    patientName: 'ชื่อคนไข้',
    numberOpd: 'หมายเลข OPD',
    openOpd: 'เปิด OPD (ครั้ง)',
    receiveTreatmentService: 'รับการรักษา/บริการ (ครั้ง)',
    getCounseling: 'รับการปรึกษา (ครั้ง)',
    onLine: 'ออนไลน์ (ครั้ง)',
    medicalAssistant: 'แพทย์ผู้ช่วย',
    medicalDoctor: 'แพทย์ผู้รักษา',
    treatment: 'การรักษา',
    total: 'ยอดรวม',
    list: 'รายการ',
    download: 'ดาวน์โหลด',
    downloadListPage: 'หน้ารายการดาวน์โหลด'
  },
  moneyReceiptReport: 'รายงานการรับเงิน',
  moneyReceiptReports: {
    date: 'วันที่รับเงิน',
    productSales: 'ยอดขายสินค้า (บาท)',
    formulaSales: 'ยอดขายสูตรยา (บาท)',
    serviceSales: 'ยอดการบริการ (บาท)',
    courseSales: 'ยอดการคอร์ส (บาท)',
    totalSales: 'ยอดรวมบาท (บาท)',
    totalDiscounts: 'ส่วนลดทั้งหมด (บาท)',
    netTotal: 'ยอดรวมสุทธิ (บาท)',
    cash: 'เงินสด (บาท)',
    transfer: 'โอนเงิน (บาท)',
    creditCard: 'บัตรเครดิต (บาท)',
    refunds: 'คืนเงิน (บาท)',
    productCommission: 'ค่าคอมมิชชั่นสินค้า (บาท)',
    productCommissionPercent: 'ค่าคอมมิชชั่นสินค้า (เปอร์เซ็นต์)',
    formulaCommission: 'ค่าคอมมิชชั่นสูตรยา (บาท)',
    doctorFee: 'ค่ามือ (บาท)',
    treatmentFee: 'ค่าตรวจรักษา (บาท)',
    seatFee: 'ค่านั่ง (บาท)',
    actualRevenue: 'รายรับจริง (บาท)'
  },
  ingredientQuantityReport: 'รายงานส่วนผสม',
  ingredientQuantityReports: {
    ingredientNo: 'รหัสส่วนผสม',
    name: 'ชื่อส่วนผสม',
    ingredientCategoryInfo: 'หมวดหมู่',
    price: 'ราคาขายต่อหน่วย (บาท)',
    qtySold: 'จำนวนที่ขายได้',
    totalAmount: 'ยอดรวม (บาท)',
    discountAmount: 'ส่วนลดทั้งหมด (บาท)',
    netAmount: 'ยอดรวมสุทธิ (บาท)',
    commissionAmount: 'ค่าคอมมิชชั่นสูตรยา (บาท)',
    refundAmount: 'คืนเงิน (บาท)',
    actualRevenue: 'รายรับจริง (บาท)',
    searchIngredientNo: 'ค้นหารหัสส่วนผสม ชื่อส่วนผสม',
    selectCategory: 'เลือกหมวดหมู่'
  },
  productQuantityReport: 'รายงานสินค้า',
  productQuantityReports: {
    image: 'รูป',
    referenceNo: 'รหัสสินค้า',
    name: 'ชื่อสินค้า',
    productCategory: 'หมวดหมู่',
    productType: 'ประเภท',
    price: 'ราคาขายต่อหน่วย (บาท)',
    qtySold: 'จำนวนที่ขายได้',
    totalAmount: 'ยอดรวม (บาท)',
    discountAmount: 'ส่วนลดทั้งหมด (บาท)',
    netAmount: 'ยอดรวมสุทธิ (บาท)',
    commissionAmount: 'ค่าคอมมิชชั่นสินค้า (บาท)',
    refundAmount: 'คืนเงิน (บาท)',
    actualRevenue: 'รายรับจริง (บาท)'
  },
  doctorIncomeReport: 'รายงานรายได้แพทย์',
  doctorIncomeReports: {
    imageUrl: 'รูป',
    doctorNo: 'รหัสพนักงาน',
    doctorName: 'ชื่อ',
    doctorTypes: 'ประเภท',
    commission: 'ค่าคอมมิชชั่น (บาท)',
    doctorFee: 'ค่ามือ (บาท)',
    treatmentFee: 'ค่าตรวจรักษา (บาท)',
    seatFee: 'ค่านั่ง (บาท)',
    total: 'ยอดรวม (บาท)'
  },
  courseSalesReport: 'รายงานการขายคอร์ส',
  courseSalesReports: {
    referenceNo: 'รหัสคอร์ส',
    name: 'ชื่อบริการ',
    courseTypeInfo: 'ประเภท',
    price: 'ราคาขาย (บาท)',
    qtySold: 'จำนวนที่ขายได้',
    totalAmount: 'ยอดรวม (บาท)',
    discountAmount: 'ส่วนลดทั้งหมด (บาท)',
    netAmount: 'ยอดรวมสุทธิ (บาท)',
    doctorFee: 'ค่ามือ (บาท)',
    treatmentFee: 'ค่าตรวจรักษา (บาท)',
    actualRevenue: 'รายรับจริง (บาท)'
  },
  tableItems: {
    yearly: 'รายปี',
    monthly: 'รายเดือน',
    custom: 'กำหนดเอง'
  },
  label: {
    list: 'รายการ'
  },
  placeholder: {
    productCommission: 'กรอกค่าคอมมิชชั่นสินค้า'
  },
  chooseDuration: 'เลือกระยะเวลา',
  noData: 'ไม่พบข้อมูล'
}
